export namespace Api {
    export const BaseUrl = process.env.NODE_ENV === 'development' ? 'https://localhost:7086' : 'https://api.kegfinder.co.uk';
}

export namespace RegexConstants {
    export const Postcode = /^([A-Z]{1,2}[0-9]{1,2}[A-Z]?)\s*([0-9][A-Z]{2})$/i;
}

export namespace AdSense {
    // Replace with your actual Google AdSense Publisher ID (format: ca-pub-XXXXXXXXXX)
    export const PublisherId = process.env.REACT_APP_ADSENSE_PUBLISHER_ID || 'ca-pub-XXXXXXXXXXXXXXXX';
}

export namespace Consent {
    export const StorageKey = 'google_cmp_consent';
    export const ExpiryDays = 365;
}